import './App.css';
import {Routes,Route, Navigate, useLocation } from 'react-router-dom'
import LoginPage from './pages/LoginPage';
import PanelLayOut from './Components/PanelLayOut';
import Dashboard from './pages/Dashboard';
import FarmInfo from './pages/FarmInfo';
import AllAnimalls from './pages/AllAnimals';
import ListDam from './pages/ListDam';
import AllSensors from './pages/AllSensors';
import SingleDam from './pages/SingleDam';
import SingleSensor from './pages/SingleSensor';
import SettingPage from './pages/SettingPageuser';
import TicketPage from './pages/TikcetPage';
import { useDispatch, useSelector } from 'react-redux';
import Settings from './pages/Settings';
import { useEffect } from 'react';
import { useGlobalContext } from './Components/Context';
import Packets from './pages/Packets';
import SinglePacket from './pages/SinglePacket';
import ErrorPage from './pages/ErrorPage';
import SingleWarning from './pages/SingleWarning';
import Terminals from './pages/Terminals';
import ListCattleHistory from './pages/CattleHistory';
import TerminalSingle from './pages/TerminalSingle';
import ListCattleParamHistory from './pages/cattleParameterHistory';
import ListSensorParamHistory from './pages/sensorParameterHistory';
import ListSensorHistory from './pages/SensorHistory';
import ListCattleHistoryCycle from './pages/CattleHistoryCycle';
 import CyclePage from './pages/CyclePage';
import StatusPage from './pages/statusPage';
import ScrollToTop from './Components/scrollToTop';
import { addCattleListComment, changeCommentMode } from './redux/slices/listDamSlice';
import CommentsPage from './pages/CommentsPage';
import { showUserExtra } from './api/helper';



function App() {
  const {currentFarms}=useSelector(state=>state.farms)
  const {cattleListAddComment,commentMode,penListComment,penCommentMode}=useSelector(state=>state.list)
  const {isLoginA}=useSelector(state=>state.p.adminA)
  const {isOpenModal,openModalls,openModalls2,isDeleteModalOpen,isOpenModal2,openDeleteModal}=useGlobalContext()
  const {pathname} =useLocation()
  const dispatch=useDispatch()
  
useEffect(()=>{
  if(commentMode){
    dispatch(changeCommentMode(commentMode))
  }else{}
  if(cattleListAddComment.length){
    dispatch(addCattleListComment([]))
  }else{}
  window.scrollTo(0,0);

  if(isOpenModal){
    openModalls();
  }
  if(isOpenModal2){
    openModalls2();
  }
if(isDeleteModalOpen){
  openDeleteModal()

}},[pathname])

  return (
    <>
    <ScrollToTop>
    <Routes>
      
      <Route path='/' element={isLoginA?(<Navigate to='/Dashboard'/>):<LoginPage/>}></Route>
      <Route path='/Setting' element={<PanelLayOut>
        <SettingPage/>
      </PanelLayOut>}></Route>
      
      <Route path='/Dashboard' element={<PanelLayOut><Dashboard/></PanelLayOut>}></Route>
      <Route path='/Settings' element={<PanelLayOut><Settings/></PanelLayOut>}></Route>
      <Route path='/FarmInfo' element={<PanelLayOut><FarmInfo/></PanelLayOut>}></Route>
      <Route path='/AllAnimalls' element={<PanelLayOut><AllAnimalls/></PanelLayOut>}></Route>
      <Route path='/ListDam' element={<PanelLayOut><ListDam/></PanelLayOut>}></Route>
      <Route path='/AllSensors' element={<PanelLayOut><AllSensors/></PanelLayOut>}>
        
      
      </Route>
      {showUserExtra&&<Route path='/Packets' element={<PanelLayOut><Packets/></PanelLayOut>}>
        
        
        
      
        </Route>}
        <Route path='/*' element={<PanelLayOut><ErrorPage/></PanelLayOut>}>
        
        
        
      
        </Route>
        {showUserExtra&&<Route path='/Packets/:id' element={<PanelLayOut><SinglePacket/></PanelLayOut>}>
        
        
      
        </Route>}
      <Route path='/ListDam/:id' element={<PanelLayOut><SingleDam/></PanelLayOut>}>
        
        
        </Route>
        <Route path='/ListDam/:id/history' element={<PanelLayOut><ListCattleHistory/></PanelLayOut>}>
        
        
        </Route>
        <Route path='/ListDam/:id/historyParameter' element={<PanelLayOut><ListCattleParamHistory/></PanelLayOut>}>
        
        
        </Route>
        <Route path='/ListDam/:id/historyCycle' element={<PanelLayOut><ListCattleHistoryCycle/></PanelLayOut>}>
        
        
        </Route>
        <Route path='/AllAnimalls/:id' element={<PanelLayOut><SingleDam/></PanelLayOut>}>
        
        </Route>
        <Route path='/Tickets' element={<PanelLayOut><TicketPage/></PanelLayOut>}>
        
        </Route>
        <Route path='/Cycle' element={<PanelLayOut><CyclePage/></PanelLayOut>}>
        
        </Route>
        <Route path='/Cycle/:id' element={<PanelLayOut><SingleDam/></PanelLayOut>}>
        
        </Route>
        
        <Route path='/Status' element={<PanelLayOut><StatusPage/></PanelLayOut>}>
        
        </Route>
        <Route path='/Status/:id' element={<PanelLayOut><SingleDam/></PanelLayOut>}>
        
        </Route>
        {showUserExtra&&<Route path='/Terminals' element={<PanelLayOut><Terminals/></PanelLayOut>}>
        
        </Route>}
        {showUserExtra&&<Route path='/Terminals/:id' element={<PanelLayOut><TerminalSingle/></PanelLayOut>}>
        
        </Route>}
        <Route path='/AllSensors/:id' element={<PanelLayOut><SingleSensor/></PanelLayOut>}>
        
        
        </Route>
        {showUserExtra&&<Route path='/AllSensors/:id/history' element={<PanelLayOut><ListSensorHistory/></PanelLayOut>}>
        
        
        </Route>}
        {showUserExtra&&<Route path='/AllSensors/:id/historyParameter' element={<PanelLayOut><ListSensorParamHistory/></PanelLayOut>}>
        
        
        </Route>}

        <Route path='/Comments' element={<PanelLayOut><CommentsPage/></PanelLayOut>}>
        
        </Route>
  
     </Routes>
    </ScrollToTop>
    </>
  );
}

export default App;
